/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxAlertsHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxAlertsTabAction,
    CashBoxAlertsTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxAlertsTabActions';

export interface CashBoxAlertsTabState {
    cashBoxAlertsHistory: CashBoxAlertsHistoryDto;
    isLoadingAlertsHistory: boolean;
    isDownloadingAlertsHistory: boolean;
}
const initialState: CashBoxAlertsTabState = {
    cashBoxAlertsHistory: null,
    isLoadingAlertsHistory: false,
    isDownloadingAlertsHistory: false,
};

export function cashBoxAlertsTabReducer(
    state: CashBoxAlertsTabState = initialState,
    action: CashBoxAlertsTabAction,
): CashBoxAlertsTabState {
    switch (action.type) {
        case CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY:
            return {
                ...state,
                isLoadingAlertsHistory: true,
            };

        case CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY_SUCCESS:
            return {
                ...state,
                cashBoxAlertsHistory: action.payload,
                isLoadingAlertsHistory: false,
            };

        case CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingAlertsHistory: false,
                cashBoxAlertsHistory: {
                    count: 0,
                    alerts: [],
                },
            };

        case CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY:
            return {
                ...state,
                isDownloadingAlertsHistory: true,
            };

        case CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY_SUCCESS:
        case CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingAlertsHistory: false,
            };

        case CashBoxAlertsTabActionType.EXIT_CASHBOX_ALERTS_TAB:
            return {
                ...state,
                cashBoxAlertsHistory: null,
            };

        default:
            break;
    }
    return state;
}
